import { Stack, useTheme } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCreateRescueTransaction } from '../../../hooks/useCreateRescueTransaction';
import { getFormattedDateDDMMYY, getFullDate } from '../../../utils/dates';
import { onRefresh } from '../../../utils/refreshPage';
import { numberWithPoint } from '../../../utils/utils';
import { ButtonsPrimary, ButtonsTertiary } from '../../ComponentApp/buttoms';
import ModalErrorFetch from '../../UI/ModalErrorFetch';
import {
  CheckBoxOutlineBlank,
  ContentCheckBox,
  DeclarationSpan,
  DescriptionText,
  DividerCustom,
  ImportanText,
  InstallmentNumbers,
  ResItemCards,
  RescueDescription,
  RescuePeriod,
  RescueSolutionSection,
  RsContent,
  TermsAndConditions,
  TextDeclaration,
  TitleItemCards,
  WarninTitle,
  WarningAmber,
  WarningMessage,
} from '../../portfolio/rescuePortfolio/CardsResultRescue';
import {
  RescueBodyContainer,
  TitleAndAmountContainer,
  TitleContainerRescue,
  TitleTextRescue,
} from '../../portfolio/rescuePortfolio/RescueComponent';
import ValueSection from '../../portfolio/rescuePortfolio/ValueSection';
import ReceivedRescueFunds from './ReceivedRescueFunds';

const CardsResultRescueFund = ({
  rescueAmount,
  cuotas,
  handleGoToConfirm,
  marketValue,
  typeProduct,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [receivedRequest, setreceivedRequest] = useState(true);
  const [responseErrorRescue, setResponseErrorRescue] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useSelector(state => state.auth);
  const { investmentSelected, investmentData } = useSelector(state => state.investments);
  const theme = useTheme();
  const navigate = useNavigate();
  const dateDDMMYY = getFormattedDateDDMMYY();
  const custom = JSON.parse(investmentSelected.custom);
  const days = custom.fund_details.plazo_rescates;
  const date = getFullDate();
  const [createRescueTransaction, { loading: loadingRescue, error: errorRescue }] =
    useCreateRescueTransaction();

  const OpenreceviedRequest = async () => {
    const data = {
      amount: Number.parseInt(investmentData.recueAmountValue),
      name: `${user.name} ${user['custom:paternal-surname']}`,
      securityId: investmentSelected.id,
      securityName: investmentSelected.name,
      units: +Number.parseFloat(investmentData.cuotasValue).toFixed(4),
    };
    try {
      if (!isSubmitting) {
        setIsSubmitting(true);
        const response = await createRescueTransaction({
          variables: {
            data: data,
          },
        });
        setResponseErrorRescue(response.data.createRescueTransaction);
        setIsSubmitting(false);
        setreceivedRequest(prevState => !prevState);
      }
    } catch (err) {
      setShowModal(!showModal);
    }
  };

  const handleChangeCheckBox = e => {
    setIsChecked(e.target.checked);
  };

  const openTC = () => {
    const { REACT_APP_CONTRACT_PORTFOLIO } = process.env;
    const win = window.open(REACT_APP_CONTRACT_PORTFOLIO, '_blank');
    win.focus();
  };

  return (
    <>
      {showModal && (
        <ModalErrorFetch
          message='Lo sentimos, algo no salio bien acá....'
          open={showModal}
          onClose={setShowModal}
          refresh={onRefresh}
        />
      )}

      {receivedRequest ? (
        <RescueBodyContainer>
          <TitleAndAmountContainer>
            <TitleContainerRescue>
              <TitleTextRescue>Rescatar inversión</TitleTextRescue>
            </TitleContainerRescue>
            <ValueSection marketValue={marketValue} typeProduct={typeProduct} />
          </TitleAndAmountContainer>

          <Stack
            sx={{
              borderRadius: '8px',
              margin: '0px auto',
              width: '100%',
              maxWidth: '1380px',
              marginTop: '30px',
            }}>
            <RescueSolutionSection sx={{ padding: 'clamp(1rem, -0.875rem + 8vw, 2.125rem)' }}>
              <RsContent>
                <RescueDescription
                  sx={{
                    padding: '24px clamp(1rem, -0.6667rem + 7.1111vw, 2rem)',
                  }}>
                  <InstallmentNumbers>
                    <TitleItemCards sx={{ color: theme.palette.primary.dark }}>
                      Monto solicitado:
                    </TitleItemCards>
                    <ResItemCards>$ {numberWithPoint(rescueAmount)}</ResItemCards>
                  </InstallmentNumbers>

                  <InstallmentNumbers>
                    <TitleItemCards sx={{ color: theme.palette.primary.dark }}>
                      Número de cuotas:
                    </TitleItemCards>
                    <ResItemCards>{cuotas}</ResItemCards>
                  </InstallmentNumbers>

                  <RescuePeriod>
                    <TitleItemCards sx={{ color: theme.palette.primary.dark }}>
                      Fecha de solicitud:
                    </TitleItemCards>
                    <ResItemCards>{dateDDMMYY}</ResItemCards>
                  </RescuePeriod>

                  <RescuePeriod>
                    <TitleItemCards sx={{ color: theme.palette.primary.dark }}>
                      Plazo de rescate:
                    </TitleItemCards>
                    <ResItemCards>{days}</ResItemCards>
                  </RescuePeriod>
                </RescueDescription>

                <WarningMessage>
                  <WarninTitle>
                    <WarningAmber src='/assets/images/perfiles/warning-amber.svg' />
                    <ImportanText>Importante:</ImportanText>
                  </WarninTitle>
                  <ul style={{ margin: '0px', padding: '0px 18px' }}>
                    <li>
                      <DescriptionText>
                        El plazo de rescate comienza a correr el día hábil siguiente si tu solicitud
                        fue realizada antes de las 4:00 PM y el día hábil subsiguiente si la
                        realizas luego de esa hora.
                      </DescriptionText>
                    </li>
                    <li>
                      <DescriptionText>
                        Este depósito es en Dólares, por lo que el monto solicitado será
                        transformado a pesos el día del depósito de acuerdo al tipo de cambio
                        correspondiente a la fecha.
                      </DescriptionText>
                    </li>
                    <li>
                      <DescriptionText>
                        El monto final a ser rescatado puede variar según el valor cuota del fondo
                        al momento de procesar el rescate.
                      </DescriptionText>
                    </li>
                  </ul>
                </WarningMessage>

                <DividerCustom variant='inset' />

                <TermsAndConditions>
                  <ContentCheckBox gap={1}>
                    <Stack marginTop={{ xs: '8px', md: '0px' }}>
                      <CheckBoxOutlineBlank checked={isChecked} onChange={handleChangeCheckBox} />
                    </Stack>
                    <TextDeclaration>
                      Declaro entender los{' '}
                      <DeclarationSpan
                        variant='span'
                        component={'span'}
                        sx={{ cursor: 'pointer' }}
                        onClick={openTC}>
                        términos y condiciones del rescate
                      </DeclarationSpan>{' '}
                      que estoy a punto de solicitar
                    </TextDeclaration>
                  </ContentCheckBox>
                </TermsAndConditions>

                <Stack
                  justifyContent={'center'}
                  direction={{ md: 'row', xs: 'column' }}
                  width={{ md: '60%', xs: '90%' }}
                  gap={2}
                  sx={{ margin: '26px 0px 0px 0px' }}>
                  <ButtonsTertiary
                    fullWidth
                    onClick={() => navigate('/myprofilerisk')}
                    name={'No por ahora'}
                  />
                  <ButtonsPrimary
                    fullWidth
                    disabled={!isChecked || loadingRescue || isSubmitting}
                    onClick={OpenreceviedRequest}
                    name={isSubmitting ? 'Solicitando' : ' Confirmar'}
                  />
                </Stack>
              </RsContent>
            </RescueSolutionSection>
            <Stack
              sx={{
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '4rem',
              }}>
              <ButtonsTertiary name='Volver Atrás ' onClick={() => handleGoToConfirm()} />
            </Stack>
          </Stack>
        </RescueBodyContainer>
      ) : (
        <Stack margin={'20px'}>
          <ReceivedRescueFunds
            responseErrorRescue={responseErrorRescue}
            cuotas={cuotas}
            rescueAmount={rescueAmount}
            investmentSelected={investmentSelected}
            dateDDMMYY={dateDDMMYY}
            days={days}
            date={date}
          />
        </Stack>
      )}
    </>
  );
};

export default CardsResultRescueFund;
